export default {
  install(Vue) {
    //{"name":"李淑鏵","phone":"0933333333","permission":"role_admin","clinic":"ladyicats","multi":true}
    Vue.prototype.$my = {
      getName: () => {
        return localStorage.getItem("authAccount")
          ? JSON.parse(localStorage.getItem("authAccount")).name
          : "";
      },
      getPhone: () => {
        return localStorage.getItem("authAccount")
          ? JSON.parse(localStorage.getItem("authAccount")).phone
          : "";
      },
      getPermission: () => {
        return localStorage.getItem("authAccount")
          ? JSON.parse(localStorage.getItem("authAccount")).permission
          : "";
      },
      getClinic: () => {
        return localStorage.getItem("authAccount")
          ? JSON.parse(localStorage.getItem("authAccount")).clinic
          : "";
      },
      setClinic: clinic => {
        if (localStorage.getItem("authAccount")) {
          let authAccount = JSON.parse(localStorage.getItem("authAccount"));
          authAccount.clinic = clinic;
          localStorage.setItem("authAccount", JSON.stringify(authAccount));
        }
      },
      isLogin: () => {
        return localStorage.getItem("authAccount") ? true : false;
      }
    };
  }
};
